import {eventMap} from './eventMap';
import {each} from '../utils';
import {fetchPath} from './fetchState';
import {formSubmit} from '../components/formSubmit';
import {
    hasUnsavedChanges,
    resetUnsavedChanges
} from '../components/unsavedChanges';

const handledNativeEvents = [
    'click',
    'change',
    'mouseup',
    'input',
    'keyup',
    'submit',
    'focusin',
    'blur'
];

const fire = (el, handler, e) => {
    const attribute = el.getAttribute(handler);
    const eventHandlers = attribute.trim().split(' ');

    eventHandlers.forEach((method) => {
        const parts = method.split('.');
        eventMap[parts[0]][parts[1]](el, e);
    });
};

const fireClosestHandler = (e) => {
    const handler = `kui-on-${e.type}`;
    const el = e.target.closest(`[${handler}]`);

    if (el) {
        fire(el, handler, e);
    }
};

const handleOnLoads = () => {
    const handler = 'kui-on-load';
    const loadEls = document.querySelectorAll(`[${handler}]`);
    each(loadEls, (el) => fire(el, handler));
};

const handleNativeEvents = () => {
    handledNativeEvents.forEach((type) => {
        document.body.addEventListener(type, fireClosestHandler, true);
    });
};

const navigate = (e) => {
    const el = e.target.closest('a');
    if (
        el &&
        el.hostname === window.location.hostname &&
        !el.hasAttribute('download') &&
        !el.hasAttribute('data-force-page-reload-via-link') &&
        !el.hasAttribute('data-in-page-link')
    ) {
        e.preventDefault();
        if (hasUnsavedChanges()) {
            if (
                !confirm(
                    `Are you sure you want to leave this page? Your changes won't be saved.`
                )
            ) {
                //  User asked to stay, do not redirect
                return;
            } else {
                resetUnsavedChanges();
            }
        }
        const path = el.pathname + el.search;

        fetchPath({path, from: window.location.pathname}, true);
    }
};

const handleInternalLinks = () => {
    document.body.addEventListener('click', navigate);
};

const handleFormSubmit = () => {
    document.body.addEventListener('submit', formSubmit);
};

const bind = () => {
    handleInternalLinks();
    handleFormSubmit();
    handleNativeEvents();
    handleOnLoads();
};

export {bind, handleOnLoads};
